import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CountryItemForAdmin from '../../../Domain/CountryItemForAdmin';
import CountryService from '../../../Services/CountryService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for countries. Single page
// with >6 fields renders as the full-screen DS wizard modal (no section nav).
export default class CountryWindowDescription {
  static titleForCreate = 'Create a new country';
  static titleForEdit = 'Edit country';
  static entityName = 'Country';
  static idField = 'CountryId';
  static nameField = 'Name';
  static itemType = CountryItemForAdmin;
  static serviceFunction = CountryService.UpsertCountry;
  static messageOnSuccess = 'Country has been saved.';
  static finishButtonLabel = 'Save';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Country Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Code',
          label: 'Code',
          className: 'col-2',
          type: InputTypesEnum.Text,
          validityChecker: (value) => CountryWindowDescription.forTextLenghtCheck(value),
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-4',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        { fieldName: 'OfficeId', label: 'Sales/FW Office', className: 'col-6', type: InputTypesEnum.OfficeSelect },
        {
          fieldName: 'EvaluatorOfficeId',
          label: 'Evaluator Payment Office',
          className: 'col-6',
          type: InputTypesEnum.OfficeSelect,
        },
        {
          fieldName: 'EvaluatorCurrencyId',
          label: 'Evaluator Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
        },
        {
          fieldName: 'LocalCurrencyId',
          label: 'Local Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
        },
        { fieldName: 'Idc', label: 'IDC', className: 'col-6', type: InputTypesEnum.Text },
        {
          fieldName: 'DefaultSchedulerUserId',
          label: 'Default Scheduler',
          className: 'col-6',
          type: InputTypesEnum.UserSelect,
        },
      ],
    },
  ];

  static forTextLenghtCheck(e) {
    if (e === undefined || e.length !== 2 || !e.match(/^[A-Za-z]+$/)) return `Must be ${2} letters`;
    return '';
  }
}
